import type { MenuItem } from "@velizhanin-dev/bot-scenario"
import { makeButtonId } from "@/entities/bot-builder"

export function mapItems(
	items: MenuItem[],
	id: string,
	change: (item: MenuItem) => MenuItem,
): MenuItem[] {
	return items.map((item) =>
		item.id === id
			? change(item)
			: item.items
				? { ...item, items: mapItems(item.items, id, change) }
				: item,
	)
}

export function removeItem(items: MenuItem[], id: string): MenuItem[] {
	return items
		.filter((item) => item.id !== id)
		.map((item) => (item.items ? { ...item, items: removeItem(item.items, id) } : item))
}

export function moveItem(items: MenuItem[], id: string, delta: -1 | 1): MenuItem[] {
	const index = items.findIndex((item) => item.id === id)
	if (index >= 0) {
		const target = index + delta
		if (target < 0 || target >= items.length) return items
		const next = [...items]
		;[next[index], next[target]] = [next[target], next[index]]
		return next
	}
	return items.map((item) =>
		item.items ? { ...item, items: moveItem(item.items, id, delta) } : item,
	)
}

export function addItem(items: MenuItem[], parentId: string | null, item: MenuItem): MenuItem[] {
	if (!parentId) return [...items, item]
	return mapItems(items, parentId, (parent) => ({
		...parent,
		items: [...(parent.items ?? []), item],
	}))
}

/** Пункт, у которого выбран «Подменю», должен сразу иметь хотя бы один пункт, так требует схема меню. */
export const placeholderChild = (): MenuItem => ({
	id: makeButtonId(),
	label: "Новый пункт",
	action: "text",
	text: "Текст ответа",
})
